import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
export const DATE_OF_BIRTH_FIELD_IDENTIFIER = 'DATE_OF_BIRTH';
export function assertsIsFieldIdentifier(val) {
  if (!(val in AddressFieldIdentifier) && val !== DATE_OF_BIRTH_FIELD_IDENTIFIER) {
    throw new Error('Value is not member of FieldIdentitifer');
  }
}